module.exports = __webpack_public_path__ + "static/media/PRIL.fd5b11e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/books/PRIL.jpg
// module id = 1370
// module chunks = 1